<script>
  export let theme_product_list;
  export let index;
</script>

<h3><i class="material-icons">place</i> 行程推薦</h3>

<div class="content_listBox">
  {#if theme_product_list.length == 0}
    <p>loading....</p>
  {:else}
    {#each theme_product_list[index] as tours}
      <div class="content_list">
        <a href={tours.product_link} target="_blank" title={tours.product_name}>
          <div class="imgBox">
            {#if tours.left_tag}
              <div class="left_tags">{tours.left_tag}</div>
            {/if}
            {#if tours.right_tag}
              <div class="right_tags">{tours.right_tag}</div>
            {/if}
            <div class="photo imgLiquidFill">
              <img src={tours.product_photo} alt="" />
            </div>
          </div>
          <div class="txtBox">
            <div class="title">{tours.product_name}</div>
            <div class="price">{tours.current_price}</div>
          </div>
        </a>
      </div>
    {/each}
  {/if}
</div>
